import { render, staticRenderFns } from "./PageEditorRightSidebar.vue?vue&type=template&id=3cb2944c&scoped=true"
import script from "./PageEditorRightSidebar.vue?vue&type=script&lang=js"
export * from "./PageEditorRightSidebar.vue?vue&type=script&lang=js"
import style0 from "./PageEditorRightSidebar.vue?vue&type=style&index=0&id=3cb2944c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2944c",
  null
  
)

export default component.exports